// extracted by mini-css-extract-plugin
export default {"menu":"style_menu__xPA2J","bt-menu":"style_bt-menu__Zb4wg","container-menu":"style_container-menu__CEzmM","item-menu":"style_item-menu__aXEd7"};